<div class="pf-footer pf-count-footer" *ngIf="countOnly">
  <div class="pf-range pf-count">
    <strong><span *ngIf="isEstimate">{{ 'PAGINATION.AROUND' | translate }} </span>{{ total | number }}</strong>
    {{ 'PAGINATION.RECORDS' | translate }}
  </div>
</div>

<div class="pf-footer" *ngIf="!countOnly">
  <!-- page size -->
  <div class="pf-size">
    <select (change)="onSize($event)">
      <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === sizeNum">{{ s }}</option>
    </select>
    <span>{{ 'PAGINATION.PER_PAGE' | translate }}</span>
  </div>

  <div class="pf-divider"></div>

  <!-- range + total -->
  <div class="pf-range">
    {{ 'PAGINATION.SHOWING' | translate }}
    <strong>{{ rangeStart }}–{{ rangeEnd }}</strong>
    {{ 'PAGINATION.OF' | translate }}
    <strong>
      <span *ngIf="isEstimate">{{ 'PAGINATION.AROUND' | translate }} </span>{{ total | number }}
    </strong>
  </div>

  <!-- stepper -->
  <div class="pf-stepper">
    <button type="button" (click)="first()" [disabled]="atStart" title="«">«</button>
    <button type="button" (click)="prev()" [disabled]="atStart" title="‹">‹</button>
    <div class="pf-page">
      {{ 'PAGINATION.PAGE' | translate }} <strong>{{ currentPage }}</strong>
      {{ 'PAGINATION.OF' | translate }} {{ pages }}
    </div>
    <button type="button" (click)="next()" [disabled]="atEnd" title="›">›</button>
    <button type="button" (click)="last()" [disabled]="atEnd" title="»">»</button>
  </div>
</div>
